import { store } from '~/utility/BinSentry-ui-utility';
import { LitEntity } from '../utility/lit-entity';
import { StoreMixin } from '../utility/store-mixin';
import { IndexMixin } from '../utility/index-mixin';
import '../common/bn-dynamically-imported';
import './import-list';
import './import-show';

export class ImportIndex extends IndexMixin(StoreMixin(LitEntity)) {
  constructor() {
    super();
    this._stateChanged(store.getState());
  }

  static get properties() {
    return {
      selectedImportHref: { type: String, attribute: false },
    };
  }

  _stateChanged({ query }) {
    if (query && query.importId) {
      this.selectedImportHref = query.importId;
    }
  }

  getViews() {
    return [
      {
        default: true,
        name: 'list',
        render: () => this._renderList({ href: this.href }),
      },
      {
        name: 'show',
        render: () => this._renderImport({ href: this.selectedImportHref, path: this.tail }),
      },
    ];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _renderList({ href }) {
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _renderImport({ href, path }) {
  }
}
